import {
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField
} from "@mui/material";
import { styled } from "@mui/system";
import { NumericFormat } from "react-number-format";

const StyledTextField = styled(TextField)({
  minWidth: "80px",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#E9EAEC",
    borderRadius: "10px"
  },
  "& .MuiInputBase-root.Mui-disabled": {
    backgroundColor: "rgb(255, 255, 255)",
    borderColor: "rgb(179, 179, 179)",
    outline: "none",
    "& fieldset": {
      borderColor: "rgb(179, 179, 179)",
      borderWidth: "0.5px"
    }
  }
});

export const Section4 = ({
  formState,
  handleChange,
  handleSectionComplete,
  reportId,
  isEditingEnabled
}) => {
  return (
    <Stack spacing={2}>
      <TableContainer sx={{ overflowX: "auto" }}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell>አዲስ የተከለቻቸው ሥ/ጣቢያዎች ብዛት</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.churchGrowth.new_branches}
                  onValueChange={values => {
                    handleChange("churchGrowth", {
                      new_branches: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ወደ አጥቢያ ያደጉ ሥርጭት ጣቢያዎች ብዛት</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.churchGrowth.branches_to_church}
                  onValueChange={values => {
                    handleChange("churchGrowth", {
                      branches_to_church: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>የአጥቢያይቱ ሥርጭት ጣቢያዎች ብዛት</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.churchGrowth.total_branches}
                  onValueChange={values => {
                    handleChange("churchGrowth", {
                      total_branches: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ሥርጭት ጣቢያዎች ስም ዝርዝር</TableCell>
              <TableCell align="center">
                <StyledTextField
                  fullWidth
                  defaultValue={formState.churchGrowth.branch_names}
                  onBlur={e =>
                    handleChange("churchGrowth", {
                      branch_names: e.target.value
                    })
                  }
                  multiline
                  minRows={4}
                  key={formState.churchGrowth.branch_names}
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      {!reportId && (
        <Stack alignItems="flex-start">
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleSectionComplete(5)}
          >
            ቀጥል
          </Button>
        </Stack>
      )}
    </Stack>
  );
};
